import $ from 'jquery';

export default ( ( $ ) => {
    $.debounce = function( delay, callback ) {
        if( callback !== undefined )
        {
            let timeout_id;

            function wrapper() {
                let that = this;
                let args = arguments;

                function exec() {
                    callback.apply( that, args );
                };

                // Clear any existing timeout.
                clearTimeout( timeout_id );
                timeout_id = setTimeout( exec, delay );
            };

            return wrapper;
        }
    };
})( $.noConflict() );